import React, { useState } from "react"
import { Button } from "react-bootstrap"



export default function ConfirmDelete({onDelete} : {onDelete: Function}){
  const [confirm, setConfirm] = useState(false)
    return (
        <div>
        {confirm ?
          <div style={{
            display: "flex"
          }}>
            <span style={{
                margin: "8px"
            }}>
                Deseja apagar este campo?
            </span>              
            <Button
              style={{
                marginLeft: "auto",
              }}
              size="sm"
              variant="danger"
              onClick={()=>onDelete()}
            >
              <i className="mdi mdi-delete-outline fs-3" />
            </Button> 
            <Button
              style={{
                marginLeft: "auto",
              }}
              size="sm"
              variant="outline"
              onClick={() => setConfirm(false)}
            >
              <i className="mdi mdi-cancel fs-3" />
            </Button>                 
          </div>
          :
          <Button
            size="sm"
            variant="outline-danger"
            onClick={() => setConfirm(true)}
          >
            <i className="mdi mdi-delete-outline fs-3" />
          </Button>
        }
        </div>
    )
}